import React from 'react';
import { Row, Col, Typography } from 'antd';
import { FileTextOutlined, MessageOutlined, VideoCameraOutlined, CalendarOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const MessagePlaceholder = () => {
  return (
    <div style={{ height: '100%', padding: '2rem', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <Title level={3} style={{ textAlign: 'center' }}>Welcome to your chat panel</Title>
      <Text style={{ textAlign: 'center', display: 'block', marginBottom: '2rem' }}>
        Your vital tool for working directly with your expert, where you can:
      </Text>

      <Row gutter={[24, 32]} justify="center">
        <Col xs={24} sm={12} md={6} style={{ textAlign: 'center' }}>
          <FileTextOutlined style={{ fontSize: '40px', color: '#1890ff' }} />
          <div style={{ marginTop: '1rem' }}>
            <strong>Share documents</strong>
            <div>securely</div>
          </div>
        </Col>

        <Col xs={24} sm={12} md={6} style={{ textAlign: 'center' }}>
          <MessageOutlined style={{ fontSize: '40px', color: '#1890ff' }} />
          <div style={{ marginTop: '1rem' }}>
            <strong>Chat</strong> in real time
          </div>
        </Col>

        <Col xs={24} sm={12} md={6} style={{ textAlign: 'center' }}>
          <VideoCameraOutlined style={{ fontSize: '40px', color: '#1890ff' }} />
          <div style={{ marginTop: '1rem' }}>
            <strong>Start a meeting</strong>
            <div>instantly</div>
          </div>
        </Col>

        <Col xs={24} sm={12} md={6} style={{ textAlign: 'center' }}>
          <CalendarOutlined style={{ fontSize: '40px', color: '#1890ff' }} />
          <div style={{ marginTop: '1rem' }}>
            <strong>Book a meeting</strong>
            <div>for later</div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default MessagePlaceholder;
